const similarReplyRequestsDescriptor = Object.freeze({
    type: 'similar-reply-requests',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(SimilarReplyRequestSelection):step-label',
    fallbackTitle: 'Similar requests',
    defaultDescriptionKey: null,
    fallbackDescription: 'Select similar requests that should receive the same reply.',
    capabilities: {
        repeatable: false,
        supportedModes: ['single'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: ['request.bulk-reply-candidates', 'request.declaration-approval'],
        writes: ['request.bulk-reply-candidates'],
    },
    effects: {
        publishes: ['request.bulk-reply-candidates.changed'],
        observes: [],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {},
    },
    settingsUi: {},
})

export { similarReplyRequestsDescriptor }
export default similarReplyRequestsDescriptor
